<div class="flex flex-col gap-[20px] justify-center items-center">
  <img src="/assets/img/devices/boiler-off.png" />
  <div class="message">
    {{ '+INSTALLATIONS.INSTALLATION.COMMISSIONING.OFFLINE_DEVICE' | translate }}
  </div>
</div>
